import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "has-text-centered" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Sign In")
], -1)
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Having trouble logging in? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!
  const _component_v_submit = _resolveComponent("v-submit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_input, {
          title: "Email Address",
          type: "email",
          value: _ctx.emailAddress,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.emailAddress = $event)),
          error: _ctx.error('emailAddress')
        }, null, 8, ["value", "error"]),
        _createVNode(_component_v_input, {
          title: "Password",
          type: "password",
          value: _ctx.password,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
          error: _ctx.error('password')
        }, null, 8, ["value", "error"]),
        _createVNode(_component_v_submit, {
          loading: _ctx.loading('signIn'),
          submitTitle: "Sign In",
          cancelTitle: "Cancel",
          onSubmit: _ctx.signIn,
          onCancel: _ctx.cancel
        }, null, 8, ["loading", "onSubmit", "onCancel"]),
        _createElementVNode("p", null, [
          _hoisted_5,
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
          }, "Forgot Password")
        ])
      ])
    ])
  ]))
}